import { vector } from '../../../visualizations/common/types.js';
import { lerpX } from '../../../visualizations/common/vector.js';
import { bounds } from '../types.js';
export const clampedYInterpolation = (x0: number, y0: number, x1: number, y1: number, boundary: bounds): vector => {
  const hasPassedTop = y0 < boundary.top;
  const hasPassedBottom = y0 > boundary.bottom;
  if (hasPassedTop || hasPassedBottom) {
    const y = hasPassedTop ? boundary.top : boundary.bottom;
    const x = lerpX(x0, y0, x1, y1, y);
    return [x, y];
  } else {
    return [x0, y0];
  }
};
export const getNextProjectedPoint = (x0: number, y0: number, x1: number, y1: number): [number, number] => {
  const deltaX = x1 - x0;
  const deltaY = y1 - y0;
  const x2 = x1 + deltaX;
  const y2 = y1 + deltaY;
  return [x2, y2];
};